/* eslint-disable prettier/prettier */
import React, { useContext } from "react";
import {
  Grid,
  RACButton,
  RACModalCard,
  Typography,
} from "@rentacenter/racstrap";
import { useTranslation } from 'react-i18next';;
import { reversePaymentStyle } from "../../stylesJS/reversePaymentStyle";
import { ReactComponent as AlertIcon } from "../../assets/images/no-records-found.svg";
import { GeneralStateContext } from "../../context/GeneralProvider";
import { GeneralStateDispatchContext } from "../../context/GeneralProvider";
export default function PostReversalException() {
  const { t } = useTranslation("translation")
  const classes = reversePaymentStyle();
  const { isPostReversalFailed } = useContext(GeneralStateContext);
  const { setIsPostReversalFailed } = useContext(GeneralStateDispatchContext);
  const buildPostException = () => {
    return (
      <Grid>
        <Grid className={`${classes.textCenter}`}>
          <AlertIcon />
          <Typography className={`${classes.bold}`}>
            {t('Failed to reverse the payment')}
          </Typography>
        </Grid>
        <Grid className={`${classes.py4} ${classes.textCenter}`}>
          <RACButton
            className={classes.mx1}
            variant="contained"
            color="primary"
            onClick={() => {
              setIsPostReversalFailed(false);
            }}
          >
            {t('OK')}
          </RACButton>
        </Grid>
      </Grid>
    );
  }; // This method will be rendering the exception when the reversal got failed.
  return (
    <RACModalCard
      isOpen={isPostReversalFailed}
      maxWidth="xs"
      borderRadius={"25px !important"}
      //eslint-disable-next-line react/no-children-prop
      children={buildPostException()}
    />
  );
}
